// 카메라 요(yaw, 수평 궤도 각) 공유 상태와 화면→월드 입력 변환(소유: 오케스트레이터 → 카메라 레인).
// 렌더 카메라(CameraRig)가 매 프레임 이동 기준 yaw(사용자 회전만, 연출 컷의 짧은 궤도 제외)를 쓰고,
// main.ts가 입력을 시뮬레이션에 넘기기 전에 읽는다.
// 시뮬레이션(src/game)은 이 파일을 쓰지 않는다: InputFrame은 언제나 월드 축이다.

/** CameraRig 규약: 0 = 카메라가 영웅의 +z 쪽에서 -z를 바라본다(기존 고정 구도). 양수 = 카메라가 +x 쪽으로 돈다. */
export const cameraYaw = { rad: 0 };

/**
 * 화면 축 입력(moveX 화면 오른쪽 +, moveZ 화면 아래 +)을 월드 XZ로 돌린다(제자리, 할당 없음).
 * yaw 0이면 그대로다. 예: yaw 90°에서 화면 위(moveZ -1)는 월드 -x.
 */
export function screenToWorld(out: { moveX: number; moveZ: number }, yaw: number): void {
  if (yaw === 0) return;
  const c = Math.cos(yaw), s = Math.sin(yaw), x = out.moveX, z = out.moveZ;
  out.moveX = x * c + z * s;
  out.moveZ = -x * s + z * c;
}

/**
 * 카메라 기준 통로 판정: (ox, oz) = 대상 − 영웅(월드). 카메라 쪽(+ (sin yaw, cos yaw))으로 min..max m, 옆으로 half m 안이면 true.
 * 보스가 영웅과 카메라 사이에 서서 영웅을 가리는지 보는 데 쓴다(월드 z 고정이 아니라 카메라 회전을 따른다).
 */
export function inCameraCorridor(ox: number, oz: number, yaw: number, min: number, max: number, half: number): boolean {
  const s = Math.sin(yaw), c = Math.cos(yaw);
  const back = ox * s + oz * c, side = Math.abs(ox * c - oz * s);
  return back > min && back < max && side < half;
}
